<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
		<v-col class="pa-0">
			<v-tabs
				app
				show-arrows
				:height="32"
				class="tabs-route"
				background-color="transparent"
				slider-color="primary">
                <v-tab exact-path ripple :to="{ path: '/opportunities/' + id + '/'}" key="opportunities">{{ $trans('opportunity') }}</v-tab>
                <v-tab exact-path ripple :to="{ path: '/opportunities/' + id + '/taskboard' }" key="taskboard" v-if="$store.getters.checkModelPermissions('task')">Taskboard</v-tab>
                <v-tab exact-path ripple :to="{ path: '/opportunities/' + id + '/timecards' }" key="timecards" v-if="$store.getters.checkModelPermissions('timecard')">Timecard</v-tab>
                <v-tab exact-path ripple :to="{ path: '/opportunities/' + id + '/quotations' }" key="quotations" v-if="$store.getters.checkModelPermissions('quotation')">Preventivi</v-tab>
			</v-tabs>

            <v-slide-y-reverse-transition>
                <router-view v-show="!$store.getters.progress" :key="$route.fullPath" :default-input="defaultInput" :entity-title="entityTitle"></router-view>
            </v-slide-y-reverse-transition>
            
        </v-col>
    </v-row>
</template>

<script>
    import breadcrumbEntityMixin from '@/mixins/breadcrumbEntityMixin'

    export default {
        mixins: [breadcrumbEntityMixin],
        name: 'opportunity',
        props: {
            id: Number,
        },

        data() {
            return {
                models: {},
                defaultInput: {}
            }
        },

        computed: {
            entityTitle()  {
                return this.models.opportunity ? ['code', 'name'].reduce((acc, key) => this.models.opportunity[key] ? acc.concat(this.models.opportunity[key]) : acc, []).join(' - ') : ''
            }
        },

        created() {
            this.$store.commit('endProgress')
            this.axios.get('opportunities/' + this.id).then(response => {
                // get body data
                this.models = response.data.models
                this.defaultInput = {'company_id': this.models.business.id, 'name': this.models.opportunity.name, 'opportunity_id': this.id}
                
            }, response => {
                // error callback
            })
        },
    }
</script>